module.exports = __webpack_public_path__ + "img/icon-share.b27afc0f.svg";